export default __webpack_public_path__ + "static/media/landing_page_feature_2.4aaf588f.png";